import React from 'react';
import { Badge } from 'react-bootstrap';

const DatabaseEnvBadge = () => {
  const databaseName = process.env.REACT_APP_FIRESTORE_DATABASE_NAME;
  
  // Debug logging
  console.log('🏷️ DatabaseEnvBadge - Environment Variable:', databaseName);
  console.log('🏷️ DatabaseEnvBadge - Resolved Database Name:', databaseName || 'default (main)');
  console.log('🏷️ DatabaseEnvBadge - Should show badge?', databaseName === 'uatrs');
  
  // Only show badge for development database (uatrs)
  if (databaseName === 'uatrs') {
    return (
      <Badge 
        bg="warning" 
        text="dark"
        className="position-fixed"
        style={{
          top: '10px',
          right: '10px',
          zIndex: 9999,
          fontSize: '0.75rem',
          padding: '6px 10px',
          borderRadius: '12px',
          boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
        }}
      >
        🔧 DEV ENV
      </Badge>
    );
  }
  
  // Return null for production (no badge)
  return null;
};

export default DatabaseEnvBadge; 